import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" />, 'FormatQuote');
